<template>
	<div class="page" @click="apply" :style="{ backgroundImage: `url(${imgtop}), url(${imgbottom})`}">
		<img class="title" :src="mainTitle" alt="标题" />
		<span class="title-text">赛程说明</span>
		<span class="title-text-bottom">本赛事全程免费，官方唯一参赛平台为中国青年报客户端。</span>
		<div>
			<div class="registration-section filter">
				<van-collapse v-model="activeCollapse" :border="false">
					<van-collapse-item name="1">
						<template slot="title">
							<div class="collapse-header" :style="{ backgroundImage: `url(${sessionBg})`}">
								<span class="collapse-title">大赛报名</span>
								<span class="collapse-date">2026.01.07至2026.05.10</span>
								<img 
									class="collapse-arrow-icon" 
									:src="mainSj" 
									:class="{ 'arrow-expanded': activeCollapse.includes('1') }"
									alt=""
								/>
							</div>
						</template>
						<div class="collapse-content">
							<div class="instruction-item">
								<span class="instruction-text">•志愿大赛<span class="link-text" @click="handleRegisterClick">选手报名</span>，请仔细阅读<span class="link-text" @click="handleRegisterClick">参赛指导</span>。</span>
							</div>
							<div class="instruction-item">
								<span class="instruction-text">•报名成功后，可查看<span class="link-text" @click="handleCertificateLink">参赛选手证</span>，此证上的参赛号是确认参赛选手身份及各赛段结果的专用编号，是参赛选手的唯一身份标识编号。</span>
							</div>
						</div>
					</van-collapse-item>
				</van-collapse>
			</div>
			
			<div class="registration-section filter">
				<van-collapse v-model="activeCollapse" :border="false">
					<van-collapse-item name="2">
						<template slot="title">
							<div class="collapse-header" :style="{ backgroundImage: `url(${sessionBg})`}">
								<span class="collapse-title">资格赛</span>
								<span class="collapse-date">2026.01.07至2026.05.10</span>
								<img 
									class="collapse-arrow-icon" 
									:src="mainSj" 
									:class="{ 'arrow-expanded': activeCollapse.includes('2') }"
									alt=""
								/>
							</div>
						</template>
						<div class="collapse-content">
							<div class="instruction-item">
								<span class="instruction-text">•资格赛将于2026年5月10日结束，请尽快完成资格赛。</span>
							</div>
							<div class="instruction-item">
								<span class="instruction-text">•本赛事以弘扬"志愿精神"为核心，参赛选手需要对志愿精神、志愿文化、志愿文学有一定了解，请先完成<span class="link-text" @click="handleQuizClick">答题测试</span>。</span>
							</div>
							<div class="instruction-item">
								<span class="instruction-text">•<span class="link-text" @click="handleUploadClick">上传作品</span>成功后，可获得<span class="link-text" @click="handlezhengming">参赛证明</span>。</span>
							</div>
							<div class="instruction-item">
								<span class="instruction-text">•<span class="link-text" @click="handleQueryResult">资格赛结果查询</span>。</span>
							</div>
						</div>
					</van-collapse-item>
				</van-collapse>
			</div>
			
			<div class="registration-section ">
				<van-collapse v-model="activeCollapse" :border="false">
					<van-collapse-item name="3">
						<template slot="title">
							<div class="collapse-header" :style="{ backgroundImage: `url(${sessionBg})`}">
								<span class="collapse-title">初赛 (省赛)</span>
								<span class="collapse-date">2026.05.11至2026.06.30</span>
								<img 
									class="collapse-arrow-icon" 
									:src="mainSj" 
									:class="{ 'arrow-expanded': activeCollapse.includes('3') }"
									alt=""
								/>
							</div>
						</template>
						<div class="collapse-content">
							<div class="instruction-item">
								<span class="instruction-text">•查看<span class="link-text" @click="handleNationalFinalTicket">初赛准考证</span>。</span>
							</div>
							<div class="instruction-item">
								<span class="instruction-text">•初赛为线下/线上考试，具体形式、时间、地点等考场信息以各赛区通知为准，请各位选手做好准备。</span>
							</div>
							<div class="instruction-item">
								<span class="instruction-text">•初赛过程中如遇到问题，请联系所在赛区进行咨询。</span>
							</div>
						</div>
					</van-collapse-item>
				</van-collapse>
			</div>
			
			<div class="registration-section filter">
				<van-collapse v-model="activeCollapse" :border="false">
					<van-collapse-item name="4">
						<template slot="title">
							<div class="collapse-header" :style="{ backgroundImage: `url(${sessionBg})`}">
								<span class="collapse-title">初赛结果查询</span>
								<img 
									class="collapse-arrow-icon" 
									:src="mainSj" 
									:class="{ 'arrow-expanded': activeCollapse.includes('4') }"
									alt=""
								/>
							</div>
						</template>
						<div class="collapse-content">
							<div class="instruction-item">
								<span class="instruction-text">入围复赛资格查询</span>
							</div>
							<div class="instruction-item">
								<span class="instruction-text">•<span class="link-text" @click="handleResultQuery">初赛结果查询</span>，查看<span class="link-text" @click="handleCertificateConfirm">初赛获奖证书</span>。</span>
							</div>
						</div>
					</van-collapse-item>
				</van-collapse>
			</div>
			
			<div class="registration-section filter">
				<van-collapse v-model="activeCollapse" :border="false">
					<van-collapse-item name="5">
						<template slot="title">
							<div class="collapse-header" :style="{ backgroundImage: `url(${sessionBg})`}">
								<span class="collapse-title">复赛(全国基础赛)</span>
								<span class="collapse-date">2026.07.01至2026.07.31</span>
								<img 
									class="collapse-arrow-icon" 
									:src="mainSj" 
									:class="{ 'arrow-expanded': activeCollapse.includes('5') }"
									alt=""
								/>
							</div>
						</template>
						<div class="collapse-content">
							<div class="instruction-item">
								<span class="instruction-text">•查看<span class="link-text" @click="handleReExamTicket">复赛准考证</span>。</span>
							</div>
							<div class="instruction-item">
								<span class="instruction-text">•复赛为线下/线上考试，具体形式、时间、地点等考场信息以大赛通知为准，请各位选手做好准备。</span>
							</div>
							<div class="instruction-item">
								<span class="instruction-text">•请选手提前了解考场环境进行模拟考试，并按照准考证信息准时进入考场。</span>
							</div>
						</div>
					</van-collapse-item>
				</van-collapse>
			</div>

			<div class="registration-section filter">
				<van-collapse v-model="activeCollapse" :border="false">
					<van-collapse-item name="6">
						<template slot="title">
							<div class="collapse-header" :style="{ backgroundImage: `url(${sessionBg})`}">
								<span class="collapse-title">复赛结果查询</span>
								<img 
									class="collapse-arrow-icon" 
									:src="mainSj" 
									:class="{ 'arrow-expanded': activeCollapse.includes('6') }"
									alt=""
								/>
							</div>
						</template>
						<div class="collapse-content">
							<div class="instruction-item">
								<span class="instruction-text">入围全国决赛资格查询</span>
							</div>
							<div class="instruction-item">
								<span class="instruction-text">•<span class="link-text" @click="handleFinalResultQuery">复赛结果查询</span>，查看<span class="link-text" @click="handleFinalCertificateConfirm">复赛获奖证书</span>。</span>
							</div>
						</div>
					</van-collapse-item>
				</van-collapse>
			</div>

			<div class="registration-section filter">
				<van-collapse v-model="activeCollapse" :border="false">
					<van-collapse-item name="7">
						<template slot="title">
							<div class="collapse-header" :style="{ backgroundImage: `url(${sessionBg})`}">
								<span class="collapse-title">全国决赛</span>
								<span class="collapse-date">2026.08</span>
								<img 
									class="collapse-arrow-icon" 
									:src="mainSj" 
									:class="{ 'arrow-expanded': activeCollapse.includes('7') }"
									alt=""
								/>
							</div>
						</template>
						<div class="collapse-content">
							<div class="instruction-item">
								<span class="instruction-text">•查看<span class="link-text" @click="handleNationalFinalTicket">全国决赛准考证</span>。</span>
							</div>
							<div class="instruction-item">
								<span class="instruction-text">•决赛为线下/线上考试，具体形式、时间、地点等考场信息以大赛通知为准，请各位选手做好准备。</span>
							</div>
							<div class="instruction-item">
								<span class="instruction-text">•请选手提前了解考场环境进行模拟考试，并按照准考证信息准时进入考场。</span>
							</div>
						</div>
					</van-collapse-item>
				</van-collapse>
			</div>

			<div class="registration-section filter">
				<van-collapse v-model="activeCollapse" :border="false">
					<van-collapse-item name="8">
						<template slot="title">
							<div class="collapse-header" :style="{ backgroundImage: `url(${sessionBg})`}">
								<span class="collapse-title">全国决赛结果查询</span>
								<img 
									class="collapse-arrow-icon" 
									:src="mainSj" 
									:class="{ 'arrow-expanded': activeCollapse.includes('8') }"
									alt=""
								/>
							</div>
						</template>
						<div class="collapse-content">
							<div class="instruction-item">
								<span class="instruction-text">•<span class="link-text" @click="handleNationalFinalResultQuery">全国决赛结果查询</span>，查看<span class="link-text" @click="handleNationalFinalCertificateConfirm">全国决赛获奖证书</span>。</span>
							</div>
						</div>
					</van-collapse-item>
				</van-collapse>
			</div>
		</div>
		
		<div class="intro-section">
			<div class="intro-title border-radius-top">大赛简介</div>
			<div class="intro-card">
				<div class="intro-paragraph">
					"同颂中华·全国青少年志愿文学创作与诵读大赛"（简称"志愿大赛"）是入选教育部《2025-2028学年面向中小学生的全国性竞赛活动名单》的公益赛事。大赛由中国青年报社主办，凡是以文字或语言歌颂奉献、传递友爱、彰显互助、追求进步的内容，都能报名参加。
				</div>
				<div class="intro-paragraph">
					大赛以弘扬"奉献、友爱、互助、进步"的志愿精神为核心，鼓励中小学生通过文学创作与诵读的形式，生动讲述志愿故事、传递温暖力量、彰显时代担当，推动更多青少年在文学创作与诵读中认识世界、认识社会、认识自己，发现"我能为他人做什么""我能为祖国做什么"；希望让每一个中小学生都能在志愿者的故事里看见榜样、找到方向，在讲述中体会温暖，在行动中学会担当，响应习近平总书记"从小就要立志向、有梦想"的殷切期望。
				</div>
			</div>
			<div class="intro-title">参赛对象</div>
			<div class="intro-card">
				<div class="intro-paragraph">
					全国中小学生
				</div>
				<div class="intro-paragraph">
					（含小学、初中、普通高中、中职学校学生）
				</div>
			</div>
			<div class="intro-title">大赛时间</div>
			<div class="intro-card">
				<div class="time-item" v-for="(item, idx) in timeList" :key="idx">
					<span class="time-text">{{ item }}</span>
				</div>
			</div>
			<div class="intro-title">联系方式</div>
			<div class="intro-card">
				<div class="intro-paragraph">
					大赛组委会办公室 <br>
					联系电话：010-64098976（肖老师） <br>
					电子邮箱：zhiyuandasai@cyd.cn <br>
					监督电话：010-64098977（卫老师）<br>
				</div>
			</div>
			
		</div>
		<img :src="mainBanner" class="bottom-banner" alt="横幅" />
		<div class="height-100"></div>
    <Footer ></Footer>
		
	</div>
</template>

<script>
import { Collapse, CollapseItem } from 'vant'
import Footer from "../components/Footer";
import axios from 'axios'
import wx from 'weixin-js-sdk'
export default {

  components: {
    Footer,
    'van-collapse': Collapse,
    'van-collapse-item': CollapseItem
  },
  data() {
    return {
      title: 'main',
      // 图片导入
      imgtop: require('@/assets/images/main_bg_top.jpg'),
      imgbottom: require('@/assets/images/main_bg_bottom.jpg'),
      leftIcon: require('@/assets/images/main_share.png'),
      sessionBg: require('@/assets/images/session_bg.png'),
      processOn: require('@/assets/images/main_process_on.png'),
      process: require('@/assets/images/main_process.png'),
      processIcon: require('@/assets/images/main_process_icon.png'),
      mainBack: require('@/assets/images/main_back.png'),
      mainZs: require('@/assets/images/main_zs.png'),
      mainMe: require('@/assets/images/main_me.png'),
      mainShare: require('@/assets/images/main_share.png'),
      mainTitle: require('@/assets/images/main_title.png'),
      mainTz: require('@/assets/images/main_tz.png'),
      mainKf: require('@/assets/images/main_kf.png'),
      mainSj: require('@/assets/images/main_sj.png'),
      mainText: require('@/assets/images/main_text.png'),
      mainBanner: require('@/assets/images/main_banner.jpg'),
      mainTop: require('@/assets/images/main_top.png'),
      tipList: [
        { title: '大赛报名今日开启1', post_id: '', content_type: '' }
      ],
      newsList: [],
      timeList: [
        '报名（资格赛）：2026年1月7日-5月10日',
        '初赛（省赛）：2026年5月11日-6月30日',
        '复赛（全国基础赛）：2026年7月1日-7月31日',
        '全国决赛：2026年8月中下旬'
      ],
      contactList: [
        { area: '北京', name: '卫老师', phone: '13581653523' },
        { area: '天津', name: '卫老师', phone: '13581653523' },
        { area: '河北', name: '苗老师', phone: '18612289972' },
        { area: '山西', name: '苗老师', phone: '18612289972' },
        { area: '内蒙古', name: '苗老师', phone: '18612289972' },
        { area: '辽宁', name: '苗老师', phone: '18612289972' },
        { area: '吉林', name: '苗老师', phone: '18612289972' },
        { area: '黑龙江', name: '赵老师\n苗老师', phone: '13011115588\n18612289972' },
        { area: '上海', name: '肖老师', phone: '17601090609' },
        { area: '江苏', name: '肖老师', phone: '17601090609' },
        { area: '浙江', name: '肖老师', phone: '17601090609' },
        { area: '安徽', name: '肖老师', phone: '17601090609' },
        { area: '福建', name: '梁老师\n肖老师', phone: '13121399117\n17601090609' },
        { area: '江西', name: '肖老师', phone: '17601090609' },
        { area: '山东', name: '苗老师', phone: '18612289972' },
        { area: '河南', name: '刘老师', phone: '13321106039' },
        { area: '湖北', name: '刘老师', phone: '13321106039' },
        { area: '湖南', name: '冯老师\n刘老师', phone: '18684749697\n13321106039' },
        { area: '广东', name: '刘老师', phone: '13321106039' },
        { area: '广西', name: '刘老师', phone: '13321106039' },
        { area: '海南', name: '陈老师\n肖老师', phone: '13121399118\n17601090609' },
        { area: '重庆', name: '刘老师', phone: '13321106039' },
        { area: '四川', name: '刘老师', phone: '13321106039' },
        { area: '贵州', name: '刘老师', phone: '13321106039' },
        { area: '云南', name: '齐老师\n肖老师', phone: '17687112227\n17601090609' },
        { area: '西藏', name: '卫老师', phone: '13581653523' },
        { area: '陕西', name: '卫老师', phone: '13581653523' },
        { area: '甘肃', name: '卫老师', phone: '13581653523' },
        { area: '青海', name: '卫老师', phone: '13581653523' },
        { area: '宁夏', name: '卫老师', phone: '13581653523' },
        { area: '新疆', name: '卫老师', phone: '13581653523' }
      ],
      showBackTop: false,
      registrationInfo: null,
      practise: null,
      classList: ['一年级', '二年级', '三年级'],
      showPlayerCard: false,
      xuanshouzheng: '/static/xuanshouzheng.png',
      baocun: '/static/baocun.png',
      shanchu: '/static/shanchu.png',
      activeCollapse: ['3'],
      currentTipIndex: 0,
      tipTimer: null
    }
  },
	mounted() {
    this.initWeixinShare()
    cyolStatistic({type: 'event',id: '2025baimingdanshare'});
		QDCYOL('zywx',"zywx", '')
  },
  methods: {
		apply(){
      if(this.$isCyolapp) {
        return
      }
      // alert("本活动仅限客户端内参与哦！")
      let page = btoa("pages/main/index")
      var urlShare = `cyol://news.cyol.com/share?content_type=min_program/redirect_type=default/min_program=__UNI__0BB6A9F/page=${page}/post_id=3nG702i0`;
      location.href='http://a.app.qq.com/o/simple.jsp?pkgname=com.hzpd.zqzx&ios_scheme='+encodeURI(urlShare)+'&android_scheme='+encodeURI(urlShare);
    },
		initWeixinShare() {
      const shareTitle = '首届"同颂中华·全国青少年志愿文学创作与诵读大赛"'
      const shareDesc = '唯一报名入口，全程零收费'
      const shareUrl = window.location.href.split('#')[0]
      const shareUrl1 = shareUrl
      const shareImg = 'https://s.cyol.com/themes/cyolwap/assets/images/app/wx_fx.png'
      
      // 使用axios发送请求获取微信签名
      axios({
        url: 'http://h5.cyol.com/special/weixin/getShareSignature.php',
        method: 'post',
        data: {
          url: shareUrl
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        transformRequest: [function (data) {
          // 将对象转换为URL编码格式
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }]
      }).then(res => {
        const json = res.data.data
        console.log(json)
        if (!json) {
          console.error('获取微信签名失败')
          return
        }
        
        // 配置微信JS-SDK
        wx.config({
          debug: false,
          appId: 'wx30b9bfd6e0063ff9', // 必填，公众号的唯一标识
          timestamp: json.timestamp, // 必填，生成签名的时间戳
          nonceStr: json.noncestr, // 必填，生成签名的随机串
          signature: json.signature, // 必填，签名，见附录1
          jsApiList: ['onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareTimeline', 'onMenuShareWeibo', 'onMenuShareQZone'], // 必填，需要使用的JS接口列表
          openTagList: ['wx-open-launch-app','wx-open-launch-weapp'] 
        })
        
        wx.ready(() => {
          // 微信好友
          wx.onMenuShareAppMessage({
            title: shareTitle, // 分享标题
            desc: shareDesc, // 分享描述
            link: shareUrl1, // 分享链接
            imgUrl: shareImg, // 分享图标
            type: 'link', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: () => {
              // 用户确认分享后执行的回调函数
              console.log('分享到微信好友成功')
            },
            cancel: () => {
              // 用户取消分享后执行的回调函数
              console.log('取消分享到微信好友')
            }
          })
          
          // 朋友圈
          wx.onMenuShareTimeline({
            title: shareTitle, // 分享标题
            desc: shareDesc, // 分享描述
            link: shareUrl1, // 分享链接
            imgUrl: shareImg, // 分享图标
            success: () => {
              // 用户确认分享后执行的回调函数
              console.log('分享到朋友圈成功')
            },
            cancel: () => {
              // 用户取消分享后执行的回调函数
              console.log('取消分享到朋友圈')
            }
          })
          
          // 分享到QQ
          wx.onMenuShareQQ({
            title: shareTitle, // 分享标题
            desc: shareDesc, // 分享描述
            link: shareUrl1, // 分享链接
            imgUrl: shareImg, // 分享图标
            success: () => {
              // 用户确认分享后执行的回调函数
              console.log('分享到QQ成功')
            },
            cancel: () => {
              // 用户取消分享后执行的回调函数
              console.log('取消分享到QQ')
            }
          })
          
          // 分享到腾讯微博
          wx.onMenuShareWeibo({
            title: shareTitle, // 分享标题
            desc: shareDesc, // 分享描述
            link: shareUrl1, // 分享链接
            imgUrl: shareImg, // 分享图标
            success: () => {
              // 用户确认分享后执行的回调函数
              console.log('分享到腾讯微博成功')
            },
            cancel: () => {
              // 用户取消分享后执行的回调函数
              console.log('取消分享到腾讯微博')
            }
          })
          
          // 分享到QQ空间
          wx.onMenuShareQZone({
            title: shareTitle, // 分享标题
            desc: shareDesc, // 分享描述
            link: shareUrl1, // 分享链接
            imgUrl: shareImg, // 分享图标
            success: () => {
              // 用户确认分享后执行的回调函数
              console.log('分享到QQ空间成功')
            },
            cancel: () => {
              // 用户取消分享后执行的回调函数
              console.log('取消分享到QQ空间')
            }
          })
        })
        
        wx.error((res) => {
          console.error('微信JS-SDK配置失败', res)
        })
      }).catch(err => {
        console.error('获取微信签名失败', err)
      })
    },

    // 证书方法
    handleCertificate() {
      const isLogin = localStorage.getItem('islogin')
      if (!isLogin || isLogin === 'false') {
        this.login()
        return
      }
      this.$toast('暂未查询到相关证书')
    },
    // 点击答题测试
    handleQuizClick() {
     
    },
    // 点击选手报名
    handleRegisterClick() {
      
    },
    // 点击参赛选手证
    handleCertificateLink() {

    },
    handleKefu() {

    },
    // 参赛选手证
    cansaiXuanshouZheng() {
      
    },
    // 点击上传作品
    handleUploadClick() {
      
    },
    // 点击参赛指导
    handlezhidao() {
      console.log('点击参赛指导')
      this.$toast('参赛指导')
    },
    // 点击参赛证明
    handlezhengming() {
     
    },
    // 点击查询结果 
    handleQueryResult() {
     
    },
    // 点击初赛结果查询
    handleResultQuery() {
      // TODO: 跳转到初赛结果查询页面
    },
    // 点击确认初赛获奖证书
    handleCertificateConfirm() {
      // TODO: 跳转到证书确认页面
    },
    // 点击复赛准考证
    handleReExamTicket() {
      // TODO: 跳转到复赛准考证页面
    },
    // 点击复赛结果查询
    handleFinalResultQuery() {
      // TODO: 跳转到复赛结果查询页面
    },
    // 点击复赛获奖证书确认
    handleFinalCertificateConfirm() {
      // TODO: 跳转到复赛获奖证书确认页面
    },
    // 点击全国决赛准考证
    handleNationalFinalTicket() {
      // TODO: 跳转到全国决赛准考证页面
    },
    // 点击全国决赛结果查询
    handleNationalFinalResultQuery() {
      // TODO: 跳转到全国决赛结果查询页面
    },
    // 点击全国决赛获奖证书确认
    handleNationalFinalCertificateConfirm() {
      // TODO: 跳转到全国决赛获奖证书确认页面
    },
    // 点击全国总展演查询
    handleNationalShowQuery() {
      // TODO: 跳转到全国总展演查询页面
    },
    // 回到顶部
    handleBackTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
.height-100 {
	height: 112px;;
}
.page {
	min-height: 100vh;
	background-color: #092E9B;
	background-position: 
		top center,
		bottom center;
	background-size: 
		750px 831px,
		750px 695px;
	background-repeat: no-repeat;
	position: relative;
	text-align: justify;
	padding-top: 44px;
}

.nav-bar {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 20px;
	background-color: transparent;
	z-index: 1000;
}

.nav-left {
	display: flex;
	align-items: center;
}

.nav-right {
	display: flex;
	width: 380px;
	align-items: center;
	gap: 8px;
	padding-right: 10px;
	justify-content: space-between;
}

.nav-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 58px;
	height: 58px;
	flex-shrink: 0;
	cursor: pointer;
}
.nav-btn-log {
	width: 142px;
}
.nav-icon {
	height: 58px;
	max-width: 100%;
}

.title {
	width: 688px;
	height: 191px;
	margin: 40px auto 80px;
	display: block;
	max-width: 90%;
}

.top-tip {
	width: 692px;
	max-width: 90%;
	height: 114px;
	background-image: url('/static/images/news_bg.png');
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center;
	border-radius: 20px;
	margin: auto;
	display: flex;
	align-items: center;
	padding: 8px 24px;
	box-sizing: border-box;
}

.tip-icon {
	width: 48px;
	height: 48px;
	flex-shrink: 0;
	margin-right: 20px;
}

.tip-content {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 8px;
}

.tip-first {
	font-size: 26px;
	color: #FFFFFF;
	line-height: 1.4;
	width: 588px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	cursor: pointer;
}

.tip-swiper-wrapper {
	width: 100%;
	height: 36px;
	overflow: hidden;
	position: relative;
}

.tip-swiper {
	width: 100%;
	transition: transform 0.5s ease;
}

.tip-swiper-item {
	width: 100%;
	height: 36px;
	display: flex;
	align-items: center;
}

.tip-text {
	font-size: 26px;
	color: #FFFFFF;
	line-height: 1.4;
	display: block;
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	cursor: pointer;
}

.title-text {
	display: block;
	margin: 80px auto 8px;
	text-align: center;
	font-weight: 800;
	font-size: 55px;
	color: #FFFFFF;
	line-height: 94px;
}

.process-section {
	white-space: nowrap;
	width: 100%;
	overflow-x: auto;
	display: flex;
	align-items: center;
}

.process-icon {
	display: inline-block;
	width: 114px;
	height: 155px;
	background-size: 100% 100%;
	flex-shrink: 0;
}

.process-text-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-evenly;
	height: 155px;
}
.process-item {
	display: inline-block;
	width: 364px;
	height: 155px;
	background-size: 100% 100%;
	position: relative;
	left: -15px;
	overflow-y: hidden;
	flex-shrink: 0;
}

.process-text {
	font-weight: bold;
	font-size: 38px;
	color: #0F3FAD;
}
.process-text1 {
	font-weight: bold;
	font-size: 26px;
	color: #0F3FAD;
}

.title-text-bottom {
	display: block;
	color: #FFFFFF;
	text-align: center;
	font-size: 25px;
	margin-bottom: 20px;
}

.registration-section {
	margin: 40px auto;
	width: 690px;
	max-width: 90%;
	border-radius: 16px;
	overflow: hidden;
}

.collapse-header {
	display: flex;
	align-items: center;
	height: 74px;
	justify-content: space-between;
	padding: 0 20px 0 20px;
	border-radius: 16px;
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center;
}

.collapse-title {
	font-size: 36px;
	font-weight: bold;
	color: #0163D7;
	width: 290px;
}

.collapse-date {
	width: 300px;
	text-align: right;
	font-size: 26px;
	color: #0163D7;
}

.collapse-content {
	padding: 20px;
	background-color: #FFFFFF;
}

.instruction-item {
	margin-bottom: 20px;
	line-height: 1.8;
}

.instruction-item:last-child {
	margin-bottom: 0;
}

.instruction-text {
	font-size: 30px;
	color: #333;
	line-height: 1.8;
}

.link-text {
	color: #0163D7;
	text-decoration: underline;
	cursor: pointer;
}

.intro-section {
	width: 690px;
	max-width: 90%;
	border-radius: 16px;
	margin: 30px auto 0;
}

.intro-card {
	background: #FFFFFF;
	padding: 16px 24px 28px;
	color: #2b2b2b;
	font-size: 30px;
	line-height: 1.7;
	box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}
.border-radius-top {
	border-radius: 16px 16px 0 0;
}

.intro-title {
	font-size: 36px;
	font-weight: 800;
	padding: 0 20px;
	color: #0A5ACF;
	height: 74px;
	background: #E6F6FF;
	line-height: 74px;
}

.intro-paragraph + .intro-paragraph {
	margin-top: 16px;
}

.time-item {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 16px;
}

.time-item:last-child {
	margin-bottom: 0;
}

.time-text {
	font-size: 30px;
	color: #333;
	line-height: 1.6;
}

.contact-card {
	overflow: hidden;
	border: 1px solid #CAE4FF;
}

.contact-header, .contact-row {
	display: flex;
	align-items: center;
}

.contact-header {
	background: #E6F6FF;
	font-weight: 700;
	color: #333;
}

.contact-row {
	background: #ffffff;
	color: #333;
}
.contact-row:nth-child(2n+3) {
	background: #E6F6FF;
	color: #333;
}

.contact-th, .contact-td {
	flex: 1;
	padding: 0 16px;
	font-size: 30px;
	text-align: center;
	box-sizing: border-box;
}
.contact-th1, .contact-td1 {
	width: 180px;
	padding: 0 16px;
	font-size: 30px;
	text-align: center;
	box-sizing: border-box;
}

.contact-multi {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.contact-text {
	display: block;
	line-height: 1.5;
}

.back-top {
	position: fixed;
	right: 24px;
	bottom: 120px;
	width: 75px;
	height: 75px;
	z-index: 999;
	cursor: pointer;
}

.back-top-icon {
	width: 75px;
	height: 75px;
	display: block;
}

.text-image {
	width: 658px;
	max-width: 90%;
	height: 334px;
	margin: 32px auto;
	display: block;
}

.bottom-banner {
	width: 750px;
	max-width: 100%;
	height: 222px;
	display: block;
}

.filter {
	filter: grayscale(100%);
}

/* 选手证弹窗 */
.visibility {
	visibility: hidden;
}

.canvas-popup {
	overflow: hidden;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.8);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	z-index: 9999;
}

.baocun {
	width: 274px;
	height: 74px;
	margin: 50px 0 30px;
	cursor: pointer;
}

.shanchu {
	width: 46px;
	height: 46px;
	cursor: pointer;
}

.canvas-view,
.mycanvas {
	width: 344px;
	height: 455px;
	background: transparent;
}

/* Vant Collapse 样式覆盖 */
::v-deep .van-collapse-item__title {
	background: #E6F6FF !important;
	padding: 0 !important;
}

::v-deep .van-collapse-item__content {
	padding: 0 !important;
}

/* 隐藏默认的 van-cell__right-icon */
::v-deep .van-cell__right-icon {
	display: none !important;
}

/* 自定义箭头图标样式 */
.collapse-arrow-icon {
	width: 25px;
	height: 20px;
	flex-shrink: 0;
	transition: transform 0.3s ease;
}

/* 展开状态下的箭头旋转 */
.collapse-arrow-icon.arrow-expanded {
	transform: rotate(-180deg);
}
</style>

